import React from "react";
// import { useHistory } from 'react-router-dom';
// import { LangCtx } from "../../lib/context";
import "../../ui-styles/termsncond/terms.css";


const PrivacyPolicy = (props) => {
    // const history = useHistory();
    // const { l } = useContext(LangCtx);

    // const handleReconnect = () => {
    //     history.push("/");
    // }

    return (
        // <PageCenterMsg src="/images/icons/privacy-policy.png" Heading={l.privacy_hdng} label={l.policy_desc} size="Lg" background="background" />
        <div className="termsnCondContainer">
        <h2 align="center">Privacy   Policy </h2>
        <p>
            Peoplelink Unified Communications Pvt Ltd (<b>“We”</b>,<b> “Our” </b>or the <b>“Company”</b>) is an entity 
            registered in India engaged in the business, inter alia, of providing Video Conferencing to the 
            customers in their quest for digital transformation and other locations (the <b>“Services”</b>). Any 
            person who wishes to procure the Services (the <b>“User”</b>, <b>“Your”</b> or <b>“You”</b>) may access our 
            website (the <b>“Website”</b>) at <a href="https://www.peoplelinkvc.com/" rel="noopener noreferrer">https://www.peoplelinkvc.com/ </a>or 
            <a href="https://www.peoplelinkvc.com/" rel="noopener noreferrer"> https://app.inclinic.vc</a> and, 
            subject to submission of the required documents, fulfilment of certain criteria and provision 
            of information which may include Personal Information the User can obtain use of the 
            Services from the Website. 
        </p>
        <br/>
        <p>&emsp;       
            The Company is committed to ensuring that the privacy of its clients, visitors, and Users of 
            the Website is always respected. This Privacy Policy serves as a testament to Our sincere 
            efforts to uphold privacy laws. The User’s privacy and the protection of the User’s personally 
            identifiable information (<b>“Personal Information”</b>) is one of our top priorities. We assure the 
            User that we follow appropriate and necessary standards when it comes to protecting the 
            User’s privacy.    
        </p>
        <br/>
        <p>&emsp;
            PeopleLink, associates and subsidiaries are committed towards protecting the privacy of its 
            user/users and offer them a positive experience with the inClinic website or while using the 
            inClinic Solutions. The Privacy Policies mentioned herein is applicable for 
            individuals/entities using the inClinic website. Our Privacy Policies are in complete 
            accordance with the global customer privacy and data protection practises. We gurantee 1) 
            that we DO NOT sell or give away your (users’) information including, their name, email, 
            location, or any other information to anyone. 
         </p>
         <br/>
        <p><b>&emsp;
            BY USING OUR SERVICES, PLATFORM,AND THE APP OR BY OTHERWISE 
            GIVING US YOUR INFORMATION YOU AGREE TO THE TERMS OF THIS 
            PRIVACY POLICY. YOU ALSO EXPRESSLY CONSENT TO OUR USE AND 
            DISCLOSURE OF YOUR PERSONAL INFORMATION (AS DEFINED BELOW) IN 
            THE MANNER PRESCRIBED UNDER THIS PRIVACY POLICY AND FURTHER 
            SIGNIFY YOUR AGREEMENT TO THIS PRIVACY POLICY [AND THE END 
                USER LICENSE AGREEMENT (AVAILABLE AT <a href="https://app.inclinic.vc" rel="noopener noreferrer">https://app.inclinic.vc</a> . IF YOU DO 
            NOT AGREE TO THIS PRIVACY POLICY, DO NOT SUBSCRIBE TO THE 
            SERVICES, USE THE APPLICATION AND DO NOT GIVE US ANY OF YOUR 
            INFORMATION.
        </b>
        </p>
         <br/>
        <h3>Capturing user information </h3>
        <br/>
        <p>&emsp;
            For using inClinic solutions, you need to register an account with us, hence flourish some of 
            your personal information like your first and last name, phone number, location, a valid email 
            id and billing information.    
         </p>
        <br/>
        <h3>User Information Usage</h3>
        <br/>
        <p>&emsp;
            PeopleLink needs your personal information (name, location, phone number ,email. Address. 
            Billing information etc.) as your individual identification. These information are generally 
            required for registering your Id, contacting you, send you email newsletters or fullfill other 
            legal purposes as required by the law. We collect your personal information or may engage a  
            third-parties to assists us in collecting the user information primarily for the purposes like     
        </p>
        <br/>
        <p>
            Registering your id, sending your newsletters <br/>
            Make certain features available for you <br/>
            Customizing your user experience <br/>
        </p>

        <br/>
        <h3>COLLECTION AND USE OF PERSONAL DATA FROM WEBSITE </h3>
        <br/>
        <p>&emsp;
            As a rule, all visits to our site <a href="https://www.peoplelinkvc.com/" rel="noopener noreferrer">https://www.peoplelinkvc.com/ </a>
                or <a href="https://app.inclinic.vc" rel="noopener noreferrer">https://app.inclinic.vc</a> are 
            anonymous. However, some of our web pages use cookies, tags or other tracking 
            technologies to monitor website activity. In addition to any Personal Information or other 
            information that You choose to submit to us, we may use a variety of technologies that 
            automatically (or passively) collect certain information whenever You access the Website 
            (<b>“Usage Information”</b>). This Usage Information may include the browser that You are using, 
            the URL that referred You to the Website and information regarding the devices used by You 
            to access the Website, among other information. Usage Information may be non-identifying 
            or may be associated with You. Whenever we associate Usage Information or a device 
            identifier with Your Personal Information, we will treat it as Personal Information and the 
            conditions relating to Personal Information under this Privacy Policy will be followed. Traffic 
            data, while anonymous, is gathered and analyzed for business needs. Further, a User 
            accessing the Website may get cookies from our advertisers. We do not control these cookies, 
            and once a User has clicked on the advertisement and left our Website, this Privacy Policy no 
            longer applies and shall be governed by the Privacy Policy of such advertiser.    
        </p>
        <br/>
        <p>&emsp;
            We may, at a time, ask You for Your personal and business information such as name, 
            address, email address, designation, organization, country You belong to, in order to provide 
            You information on our services. We will use Your information to respond to You, regarding 
            the reason You contacted us.   
        </p>
        <br/>
        <h3>THIRD PARTY CONTENT AND LINKS TO THEIR SERVICES </h3>
        <br/>
        <p>&emsp;
            The Website may contain content that is supplied by a third party, and those third parties may 
            collect website usage information and other information when web pages from any online or 
            mobile services are provided to Your browser. In addition, when You are using the Website, 
            You may be directed to other websites that are operated and controlled by third parties that 
            we do not control. We are not responsible for the privacy practices employed by any of these 
            third parties. These other websites may send their own cookies to You, independently collect 
            data or solicit Personal Information and may or may not have their own published privacy 
            policies. When You leave the Website, we encourage You to read the privacy statements of all 
            third party websites before submitting any information to third parties.   
        </p>
        <br/>
        <h3>COLLECTION AND USE OF PERSONAL DATA FOR DIRECT MARKETING PURPOSES</h3>
        <br/>
        <p>&emsp;
            Personal data we collect and use for marketing purposes relates to existing clients & 
            prospects and other companies with which we have an existing or a new business 
            relationship. Microland may gather individual’s business contact information like name, 
            designation, email id, phone no, and address either from public sources, or from third party 
            data providers.   
        </p>
        <br/>
        <p>&emsp;
            We may send e-mails, or make personal telephonic calls or send e-mails to You, our existing 
            client, prospects or other companies with whom we want to develop or maintain a business 
            relationship in accordance with applicable data privacy laws.  
        </p>
        <br/>
        <h3>CONSENT AND WITHDRAWAL OF CONSENT</h3>
        <br/>
        <p>&emsp;
            Generally We do not rely on consent as a legal basis for processing Your Personal 
            Information other than in relation to sending third party direct marketing communications to 
            You via email or text message. You have the right to withdraw Your consent to marketing at 
            any time by contacting us at <a href="https://www.peoplelinkvc.com/" rel="noopener noreferrer">https://www.peoplelinkvc.com/</a>    
        </p>
        <br/>
        <h3>PROCESSING OF THE DATA </h3>
        <br/>
        <p>&emsp;
            We, our affiliates or third party service providers with whom we have entered into contractual 
            arrangements may also process any Personal Information or Usage Information collected 
            from You for legitimate commercial purposes including providing the Services. We 
            implement appropriate technical and organizational measures to ensure a level of security 
            appropriate to the risk of our processing of Personal Information  such as (i) only sharing and 
            providing access to Personal Information to the minimum extent necessary, subject to 
            appropriate contractual restrictions including confidentiality restrictions where appropriate, 
            and on an anonymized basis wherever possible; (ii) using secure servers to store Personal 
            Information; (iii) verifying the identity of any individual who requests access to Personal 
            Information prior to granting them access to such information; and (iv) using Secure Sockets 
            Layer (SSL) software or other similar encryption technologies to encrypt any payment 
            transactions You make on or via our website.   
        </p>
        <br/>
        <h3>USE OF INFORMATION COLLECTED </h3>
        <br/>
        <p>&emsp;
            We do not share any Personal Information with any third party (not being an affiliate, third 
            party service provider or a group company of Us) without Your consent, except when directed 
            by law. The Company can use Personal Information and/or Usage Information to verify User 
            identity the context of any engagement initiated by a User.   
        </p>
        <br/>
        <p><b>
            We, our affiliates or third party service providers may use Personal Information or 
            Usage Information collected in the following ways:-   
        </b></p>
        
        <ol>
            <ul className="circleList">
                <li><p>
                    to operate and improve the Website and tools associated with the Website; </p></li>
                <li><p>
                    to create aggregated and anonymized information to determine which Website features 
                    are most popular and useful to Users, and for other statistical analyses; </p></li>
                <li><p>
                    to prevent, discover and investigate violations of this Privacy Policy or the 
                    Terms and Conditions, and to investigate fraud or other matters;  </p></li>
                <li><p>
                    to customize the content or the Services on the Website for You, or the 
                    communications sent to You through the Website;  </p></li>
                <li><p>
                    to provide You the Services; </p></li>
                <li><p>
                    to improve our ability to provide You the Services;  </p></li>
                <li><p>
                    to observe, improve and administer the quality of Services; </p></li>
                <li><p>
                    to analyse how the Website is used, diagnose technical problems;    </p></li>
                <li><p>
                    to remember the basic information provided by You for effective access;  </p></li>

                <li><p>
                    to confirm Your identity in order to determine Your eligibility to use the 
                    Website and avail the Services; </p></li>
                <li><p>
                    to notify You about any changes to the Website; </p></li>
                <li><p>
                    to transmit, share or transfer the data to a group company or affiliate of Us to 
                    enable such group company or Affiliate to provide You with the Services;  </p></li>
                <li><p>
                    to enable Us to comply with Our legal and regulatory obligations;  </p></li>
                <li><p>
                    for the purpose of sending administrative notices, Service related alerts and 
                    other similar communication with a view to optimizing the efficiency of the 
                    Website;</p></li>
                <li><p>
                    to do market research, troubleshooting or project planning,   </p></li>
                <li><p>
                    to protect against errors, fraud and other criminal activity; and    </p></li>
                <li><p>
                    to reinforce the Terms of Use.   </p></li>
            </ul>
        </ol>

        <br/>
        <h3>SECURITY MEASURES </h3>
        <br/>
        <p>&emsp;
            We maintain technical and organizational measures to safeguard the personal data we hold. 
            This includes necessary controls and relevant policies, procedures and guidance taking into 
            account the risks associated with the categories of personal data and the processing we 
            undertake. 
   
        </p>
        <br/>
        <h3>DATA RETENTION </h3>
        <br/>
        <p>&emsp;
            Your information will be retained by Us for as long as it is needed for Us to provide the 
            Services to You. The Company will retain and use your information as necessary to comply 
            with legal obligations. If You wish to cancel Your account or request that we no longer 
            collect, process or retain Your information to provide Services, You may contact Us at 
            <a href="https://help.peoplelinkvc.com/portal/en/newticket" rel="noopener noreferrer"> https://help.peoplelinkvc.com/portal/en/newticket. </a> When the Company has no ongoing 
            legitimate business need to process Your information, we will either delete the information or 
            anonymize it.    
        </p>
        <br/>
        <h3>SECURITY  </h3>
        <br/>
        <p>&emsp;<mark>
            Personal Information and Usage Information we collect is securely stored within our 
            databases, and we use standard, industry-wide, commercially reasonable security 
            practices such as encryption, firewalls and SSL (Secure Socket Layers) for protecting  
            Your information.     
        </mark></p>
        <br/>
        <h3>NOTIFICATION IN CASE OF BREACH  </h3>
        <br/>
        <p>&emsp;
            In the event that Personal Information is compromised as a breach of security, the Company 
            will promptly notify You in compliance with the applicable law.    
        </p>
        <br/>
        <h3>CHILDREN’S PRIVACY </h3>
        <br/>
        <p>&emsp;
            Protecting the privacy of young children is especially important. For that reason the Company 
            does not knowingly collect or solicit Personal Information from anyone under the age of 13. 
            In the event that we learn that we have collected Personal Information from a child under age 
            13, we will delete that information as quickly as possible. If You believe that we might have 
            any information from or about a child under age 13, please contact us by creating a ticket at 
            <a href="https://help.peoplelinkvc.com/portal/en/newticket" rel="noopener noreferrer"> https://help.peoplelinkvc.com/portal/en/newticket </a>   
        </p>
        <br/>
        <h3>CHANGE IN INFORMATION AND CANCELLATION OF ACCOUNT </h3>
        <br/>
        <p>&emsp;
            You are responsible for maintaining the accuracy of the information You submit to us, such as 
            Your contact information provided as part of account registration. If Your Personal 
            Information changes, or if You no longer desire to access the Website, You may correct, 
            delete inaccuracies, or amend information by making the change on our member information 
            page or by contacting us through <a href="https://help.peoplelinkvc.com/portal/en/newticket" rel="noopener noreferrer"> https://help.peoplelinkvc.com/portal/en/newticket </a> 
            and We will respond within 96 hours of receipt of communication.   
        </p>
        <br/>
        <p>&emsp;
            You may also cancel or modify Your communications that You have elected to receive from 
            the Website by logging into Your User account and changing Your communication 
            preferences or by submitting ticket at <a href="https://help.peoplelinkvc.com/portal/en/newticket" rel="noopener noreferrer"> https://help.peoplelinkvc.com/portal/en/newticket </a>  
        </p>
        <br/>
        <p>&emsp;
            If You wish to cancel Your account or request that we no longer use Your Personal 
            Information to provide You with details with respect to our Services and the Website, please 
            inform us at <a href="https://help.peoplelinkvc.com/portal/en/newticket" rel="noopener noreferrer">https://help.peoplelinkvc.com/portal/en/newticket</a> 
        </p>
        <br/>
        <h3>CHANGES TO THIS POLICY  </h3>
        <br/>
        <p>&emsp;
            From time to time, We may update this Privacy Policy to reflect changes to Our information 
            practices. Any changes will be effective immediately upon the posting of the revised Privacy 
            Policy on the Website. If We make any material changes, We will notify You by email (sent to 
            the e-mail address specified in Your account) or by means of a notice on the Website prior to  
            the change becoming effective. We encourage You to periodically review this page for the 
            latest information on our privacy practices.   
        </p>
        <br/>
    </div>
    )
}
export default PrivacyPolicy;
